import { render, staticRenderFns } from "./TextAttr.vue?vue&type=template&id=7b87fe06&scoped=true"
import script from "./TextAttr.vue?vue&type=script&lang=js"
export * from "./TextAttr.vue?vue&type=script&lang=js"
import style0 from "./TextAttr.vue?vue&type=style&index=0&id=7b87fe06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b87fe06",
  null
  
)

export default component.exports